import { IUserMilestone } from '../../IUserMilestone';

export const MARKETING_SMS_OPT_IN_SUBMITTED =
  'MARKETING_SMS_OPT_IN_SUBMITTED' as IUserMilestone.RetailerMilestone;
